import {
  CognitoIdentityClient,
  GetCredentialsForIdentityCommand,
  GetIdCommand,
} from '@aws-sdk/client-cognito-identity';

const IDENTITY_POOL_ID = import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID;
const USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID;
const AWS_REGION = import.meta.env.VITE_AWS_REGION;

const client = new CognitoIdentityClient({ region: AWS_REGION });

export interface AwsCredentials {
  accessKeyId: string;
  secretAccessKey: string;
  sessionToken: string;
  expiration: Date;
}

let cached: AwsCredentials | null = null;

export async function getIdentityPoolCredentials(idToken: string): Promise<AwsCredentials> {
  if (cached && cached.expiration > new Date(Date.now() + 60_000)) return cached;

  const loginKey = `cognito-idp.${AWS_REGION}.amazonaws.com/${USER_POOL_ID}`;
  const logins = { [loginKey]: idToken };

  const { IdentityId } = await client.send(
    new GetIdCommand({ IdentityPoolId: IDENTITY_POOL_ID, Logins: logins }),
  );

  const { Credentials } = await client.send(
    new GetCredentialsForIdentityCommand({ IdentityId: IdentityId!, Logins: logins }),
  );

  cached = {
    accessKeyId: Credentials!.AccessKeyId!,
    secretAccessKey: Credentials!.SecretKey!,
    sessionToken: Credentials!.SessionToken!,
    expiration: Credentials!.Expiration!,
  };

  return cached;
}

export function clearCredentialsCache(): void {
  cached = null;
}
